// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_16scW","modal-wrap":"modal-wrap_WyDKP"};